import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

const PageHeader = ({ title, breadcrumbs = [] }) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-transparent">
          {!isMobile &&<h4 className="mb-sm-0">{title}</h4>}
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {breadcrumbs?.map((item, index) => (
                <li
                  key={index}
                  className={`breadcrumb-item ${
                    item.active ? "active" : ""
                  }`}
                >
                  {item.active ? (
                    item.label
                  ) : (
                    <Link to={item.path}>{item.label}</Link>
                  )}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;